<div class="mb-3 position-relative" [formGroup]="group">
  <label [attr.for]="id" *ngIf="showLabel">
    <ng-content select="[label]"></ng-content>
    <span class="text-danger" *ngIf="requiredMsg"> *</span>
  </label>
  <div class="input-group">
    <input [readonly]="readonly" [ds365Placeholder]="placeholder"  ds365IsInvalid
      [name]="controlNameText" [attr.type]="type" [ngClass]="classes" [ngStyle]="styles" [attr.id]="id"
      [formControlName]="controlNameText" [attr.maxlength]="maxLength ? maxLength : null"
      [attr.minlength]="minLength ? minLength : null" [attr.max]="max ? max : null" [attr.min]="min ? min : null"
      (input)="onInputChange($event)" />
    <div class="input-group-append">
      <div ngbDropdown class="d-inline-block">
        <button type="button" class="btn btn-dark" [id]="'dropdown-' + id" ngbDropdownToggle>
          {{selectedOption?.title}}
           <ds365-icon svgName="arrow-down" class="icon-dropdown" svgSize="14" status="white"></ds365-icon>
        </button>
        <div ngbDropdownMenu [attr.aria-labelledby]="'dropdown-' + id" class="menu-dropdown">
          <button ngbDropdownItem *ngFor="let opt of options" [value]="opt.key" (click)="onDropdownSelect(opt)">{{
            opt.title }}</button>
        </div>
      </div>
    </div>
  </div>
  <small *ngIf="showError" [style.display]="'block'" class="mt-2 form-text text-light"
    >&nbsp;
    <ng-content select="[hints]"></ng-content>
    <span  class="text-danger" *ngIf="errorMessage" >{{errorMessage}}</span>
  </small>
</div>
